import { takeEvery, put, call } from "redux-saga/effects"

//Account Redux states
import { GROUP_REPORT, GROUP_FETCH } from "./actionTypes"
import {
  groupReportSuccessful,
  groupReportFailed,
  groupFetchSuccessful,
  groupFetchFailed
} from "./actions"
import { groupautoGenerationReport, groupFetchReportAPI } from "../../../helpers/backend_helper"

import { isEmpty } from "lodash"

function* groupReport({ payload: { groupReport, history } }) {
  try {

    const response = yield call(groupautoGenerationReport, groupReport)
    yield put(groupReportSuccessful(response))
    history.push("/report-registration-status/" + groupReport.groupToken)
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(groupReportFailed(error.response.data))
    } else {
      yield put(groupReportFailed(error.message))
    }
  }
}

function* groupFetchReport({ payload: { token } }) {
  try {
    const response = yield call(groupFetchReportAPI, {
      params: { token }
    })

    yield put(groupFetchSuccessful(response))

  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(groupFetchFailed(error.response.data))
    } else {
      yield put(groupFetchFailed(error.message))
    }
  }

}

function* groupReportSaga() {
  yield takeEvery(GROUP_REPORT, groupReport)
  yield takeEvery(GROUP_FETCH, groupFetchReport)

}

export default groupReportSaga
